import { i18n } from "translate/i18n";

export const monthName = (monthIndex) =>
  i18n.t(`messages.months.${monthIndex}`);
